export default {
    createModal: {
        newGroup: `New Group`,
        photo: `Photo`,
        upload: `Upload`,
        name: `Name`,
        namePlaceholder: `Enter group name`,
        status: `Status`,
        statusTooltip: `Status indicates whether this group is accepting new members or closed to new members.`,
        churchAppsRequired: `This function is available with a church apps purchase`,
        description: `Description`,
        showInChurchApp: `Show in Church App`,
        frequency: `Frequency`,
        frequencyTooltip: `Frequency will show in church app to indicate to members when the group meets.`,
        location: `Location`,
        locationTooltip: `Location will show in church app to indicate to members where the group meets.`,
        enableMemberChat: `Enable member chat in Church App`,
        groupsAccess: `Groups Access`,
        groupsAccessTooltip: `A leader must be added under the 'Member' tab to approve requests to join Private groups. Public groups are open to all members.`,
        private: `Private`,
        public: `Public`,
        createFromExistingTags: `Create from existing tags`,
        addGroup: `Create group`,
        addGroupWithMembers: `Create group with %{memberCount} members`,
        groupCreated: `%{name} group created!`,
        numberPeopleAdded: `%{number} people added`,
        goToGroupPage: `Go to group page`,
        goToDashboard: `Go to dashboard`,
        nameMustBe: `Name must be at least 3 characters long`,
        tagsInputLabel: `Add members from tags`,
        descriptionMustBe: `Description must be at less than 400 characters long`,
        frequencyRequiredWithShowInApp: `Frequency is required when "Show in app" is enabled.`,
        locationRequiredWithShowInApp: `Location is required when "Show in app" is enabled.`
    },
    membersModal: {
        addMembersError: `Member could not be added. Please try again later. | Members could not be added. Please try again later.`,
        addMembersOrTags: `Add members by name %{shouldShowOrTagsText}`,
        addMembersSuccess: `Member added successfully! | Members added successfully!`,
        addSelected: `Add selected`,
        alreadyInGroup: `Already in the group`,
        nameNotFound: `Uh oh! Looks like we don’t have any results for that name`,
        searchMembers: `Search by name`,
        searchTags: `Search tags`,
        unsavedChangesWarning: `You have unsaved members. Are you sure you want to exit?`
    },
    generalPage: {
        saveChanges: `Save changes`,
        deleteGroup: `Delete group`
    }
}
